import { render, staticRenderFns } from "./ValidationRadio.vue?vue&type=template&id=3cae0e04"
import script from "./ValidationRadio.vue?vue&type=script&lang=js"
export * from "./ValidationRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports